export default [
  {
    path: "/cases",
    name: "caseSearch",
    component: () =>
      import(/* webpackChunkName: "cases" */ "@/views/cases/Search.vue"),
    meta: {
      layout: "Split",
      showBack: true
    }
  },
  {
    path: "/cases/:id",
    name: "casePage",
    component: () =>
      import(/* webpackChunkName: "cases" */ "@/views/cases/Case.vue"),
    meta: {
      layout: "Split",
      showBack: true,
      headerCollapsible: true
    }
  }
];
